export default "/images/eb75628570bf8e49b56c89ebb5106186.avif";